// Liqo — registrazione push notifications native (Capacitor + Firebase FCM).
//
// Sul WEB è completamente no-op: il plugin Capacitor non viene nemmeno importato
// (import dinamico dietro al check `isNativePlatform`). Su iOS/Android: chiede il
// permesso, registra il device e invia il token FCM al backend (/api/push/register).
import { isNativePlatform } from "./native";
import { registerPushToken, unregisterPushToken } from "./api";

let _initialized = false;
let _lastToken = null;

const platformName = () => {
  try {
    return (window.Capacitor && window.Capacitor.getPlatform && window.Capacitor.getPlatform()) || "unknown";
  } catch {
    return "unknown";
  }
};

// Inizializza le push native. Idempotente. No-op sul web.
export const initPush = async () => {
  if (!isNativePlatform() || _initialized) return;
  _initialized = true;
  try {
    const { PushNotifications } = await import("@capacitor/push-notifications");

    // Token FCM ricevuto -> invialo al backend per il tenant corrente.
    await PushNotifications.addListener("registration", async (token) => {
      try {
        _lastToken = token.value;
        await registerPushToken(token.value, platformName());
        console.log("[Liqo] push token registrato");
      } catch (e) {
        console.warn("[Liqo] invio push token fallito:", e);
      }
    });

    await PushNotifications.addListener("registrationError", (err) => {
      console.warn("[Liqo] errore registrazione push:", err);
    });

    // Permessi: richiedi solo se non già concessi.
    const perm = await PushNotifications.checkPermissions();
    let receive = perm.receive;
    if (receive === "prompt" || receive === "prompt-with-rationale") {
      receive = (await PushNotifications.requestPermissions()).receive;
    }
    if (receive !== "granted") {
      console.log("[Liqo] permesso notifiche non concesso");
      return;
    }
    await PushNotifications.register();
  } catch (e) {
    console.warn("[Liqo] init push fallito:", e);
  }
};

// Deregistra il token corrente dal backend (es. al logout). No-op sul web.
export const teardownPush = async () => {
  if (!isNativePlatform() || !_lastToken) return;
  try {
    await unregisterPushToken(_lastToken);
  } catch (e) {
    console.warn("[Liqo] unregister push fallito:", e);
  } finally {
    _lastToken = null;
  }
};

export const getLastPushToken = () => _lastToken;
